import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "componentEl", "flex", "margin", "padding", "className", "fullWidth", "align", "justify", "grow", "shrink", "border", "style"];
import React from 'react';
import PropTypes from 'prop-types';
import { componentElDefaults, componentElPropTypes } from '../customPropTypes/componentEl';
import { classNamePropTypes, addClassNames } from '../customPropTypes/classNames';
import { addSpacingClasses, marginPropTypes, paddingPropTypes } from '../customPropTypes/spacing';
import { addBorderClasses, borderPropTypes } from '../customPropTypes/border';
import { jsx as _jsx } from "react/jsx-runtime";
function GroupItem(_ref) {
  var children = _ref.children,
    Component = _ref.componentEl,
    flex = _ref.flex,
    margin = _ref.margin,
    padding = _ref.padding,
    className = _ref.className,
    fullWidth = _ref.fullWidth,
    align = _ref.align,
    justify = _ref.justify,
    grow = _ref.grow,
    shrink = _ref.shrink,
    border = _ref.border,
    style = _ref.style,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var cssClasses = ['st_grp__item'];
  if (fullWidth) cssClasses.push('st_width--full');
  if (flex) cssClasses.push('st_grp__item--flex');
  cssClasses = addClassNames(className, cssClasses);
  cssClasses = addSpacingClasses({
    margin: margin,
    cssClasses: cssClasses
  });
  if (align) cssClasses.push("st_alignself--".concat(align));
  if (justify) cssClasses.push("st_justifyself--".concat(justify));
  var styleProp = style || {};
  styleProp['--st-flexgrow'] = grow;
  styleProp['--st-flexshrink'] = shrink;
  cssClasses = addBorderClasses(border, cssClasses);
  return /*#__PURE__*/_jsx(Component, _extends({
    className: cssClasses.join(' '),
    style: styleProp
  }, otherProps, {
    children: children
  }));
}
process.env.NODE_ENV !== "production" ? GroupItem.propTypes = {
  /** dom element or component to use for outermost wrapper */
  componentEl: componentElPropTypes,
  /** extra CSS classes, if any */
  className: classNamePropTypes,
  /** margin for component, if any */
  margin: marginPropTypes,
  /** padding for component, if any */
  padding: paddingPropTypes,
  /** whether item should take up 100% of available width */
  fullWidth: PropTypes.bool,
  /** item takes up rest of available space */
  flex: PropTypes.bool,
  /** align-self CSS property */
  align: PropTypes.oneOf(['flex-start', 'flex-end', 'center', 'baseline', 'stretch']),
  /** justify-self CSS property */
  justify: PropTypes.oneOf(['flex-start', 'flex-end', 'center', 'baseline', 'stretch']),
  /** flex-grow css property */
  grow: PropTypes.number,
  /** flex-shrink css property */
  shrink: PropTypes.number,
  /** whether column should show a border to the left or right */
  border: borderPropTypes
} : void 0;
GroupItem.defaultProps = {
  componentEl: componentElDefaults,
  className: null,
  margin: null,
  padding: null,
  fullWidth: false,
  flex: false,
  align: null,
  justify: null,
  grow: 0,
  shrink: 0,
  border: null
};
GroupItem.displayName = 'Group.Item';
export default GroupItem;